import {
  CHART_GRAPH,
  CHART_METRIC,
  CHART_METRIC_VIEW_TYPE,
  CHART_SHARE_CALCULATION_TYPE,
  CHART_TYPE,
} from '@/entities/chart/model/constants';

const disallowHistoricalGraphList = [
  CHART_GRAPH.BAR,
  CHART_GRAPH.PIE,
  CHART_GRAPH.TABLE,
  CHART_GRAPH.COMBO_CHART,
  CHART_GRAPH.WORD_CLOUD,
];

// Helper function for historical check
export const isAllowHistorical = (type: CHART_TYPE, graph: CHART_GRAPH) => {
  if (disallowHistoricalGraphList.includes(graph)) return false;
  if (type === CHART_TYPE.CROSS_AXIS) return false;
  return true;
};

export const directionEnabledGraphList = [
  CHART_GRAPH.BAR,
  CHART_GRAPH.BAR_STACKED,
];

export const viewTypeEnabledGraphList = [
  CHART_GRAPH.AREA,
  CHART_GRAPH.BAR_STACKED,
  CHART_GRAPH.TABLE,
  CHART_GRAPH.PIE,
];

export const viewTypeEnabledMetricList = [
  CHART_METRIC.FEEDBACK,
  CHART_METRIC.UNIQUE_ACCOUNT,
  CHART_METRIC.UNIQUE_CONTACT,
  CHART_METRIC.IMPRESSION,
  CHART_METRIC.TOTAL_ENGAGEMENT,
  CHART_METRIC.ENGAGEMENT_RATE,
];

/**
 * Metrics that require calculation selection (AVERAGE/SUM)
 */
export const calculationEnabledMetricList = [
  CHART_METRIC.TOTAL_ENGAGEMENT,
  CHART_METRIC.ENGAGEMENT_RATE,
  CHART_METRIC.IMPRESSION,
  CHART_METRIC.ACCOUNT_REVENUE_IMPACT,
  CHART_METRIC.CONTACT_REVENUE_IMPACT,
  CHART_METRIC.RATING_SCORE,
  CHART_METRIC.NPS_SCORE,
  CHART_METRIC.CSAT_SCORE,
  CHART_METRIC.CES_SCORE,
];

export const isCalculationTypeEnabled = (
  type: CHART_TYPE,
  graph: CHART_GRAPH,
  viewType?: CHART_METRIC_VIEW_TYPE,
) => {
  if (type === CHART_TYPE.SINGLE_AXIS) return false;
  if (graph !== CHART_GRAPH.TABLE) return false;
  return viewType === CHART_METRIC_VIEW_TYPE.PERCENTAGE;
};

export const isCellCalculationSegmentEnabled = (
  calculationTypeEnabled: boolean,
  shareCalculationType?: CHART_SHARE_CALCULATION_TYPE,
) => {
  if (!calculationTypeEnabled) return false;
  return shareCalculationType === CHART_SHARE_CALCULATION_TYPE.CELL;
};

export const isShowRowTotalEnabled = (
  graph: CHART_GRAPH,
  viewType?: CHART_METRIC_VIEW_TYPE,
) => {
  if (graph !== CHART_GRAPH.TABLE) return false;
  return viewType === CHART_METRIC_VIEW_TYPE.COUNT;
};

export const isViewTypeEnabled = (graph: CHART_GRAPH, metric: CHART_METRIC) => {
  return (
    viewTypeEnabledMetricList.includes(metric) &&
    viewTypeEnabledGraphList.includes(graph)
  );
};

export const isCalculationEnabled = (metric: CHART_METRIC) => {
  return calculationEnabledMetricList.includes(metric);
};
